export const InawoGreenLuxeIcon = () => {
  return (
    <svg
      width="89"
      height="40"
      viewBox="0 0 89 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.219696"
        y="0.432617"
        width="88.0579"
        height="39.0816"
        rx="18.2374"
        fill="white"
      />
      <path
        d="M15.1649 25.8409L14.8694 25.1983L15.1649 25.8409L19.0194 24.0685C19.0402 24.059 19.0642 24.059 19.085 24.0685L22.9395 25.8409C24.1987 26.4199 25.4988 25.1199 24.9197 23.8606L23.1474 20.0062C23.1378 19.9853 23.1378 19.9614 23.1474 19.9405L24.9197 16.0861C25.4988 14.8268 24.1987 13.5268 22.9395 14.1058L19.085 15.8782C19.0642 15.8877 19.0402 15.8877 19.0194 15.8782L15.1649 14.1058C13.9056 13.5268 12.6056 14.8268 13.1847 16.0861L14.957 19.9405C14.9666 19.9614 14.9666 19.9854 14.957 20.0062L13.1847 23.8606C12.6056 25.1199 13.9056 26.4199 15.1649 25.8409Z"
        stroke="#298576"
        strokeWidth="1.41446"
      />
      <path
        d="M32.8659 25.4734V15.2916H34.4021V24.151H39.0157V25.4734H32.8659ZM51.9358 15.2916H53.477V21.9884C53.477 22.701 53.3096 23.3324 52.9748 23.8825C52.6401 24.4294 52.1694 24.8603 51.5629 25.1752C50.9564 25.4867 50.2454 25.6425 49.4301 25.6425C48.6181 25.6425 47.9088 25.4867 47.3023 25.1752C46.6957 24.8603 46.2251 24.4294 45.8903 23.8825C45.5556 23.3324 45.3882 22.701 45.3882 21.9884V15.2916H46.9244V21.8641C46.9244 22.3248 47.0255 22.7341 47.2277 23.0921C47.4332 23.45 47.7232 23.7317 48.0977 23.9372C48.4722 24.1394 48.9164 24.2405 49.4301 24.2405C49.9471 24.2405 50.3929 24.1394 50.7675 23.9372C51.1453 23.7317 51.4337 23.45 51.6325 23.0921C51.8347 22.7341 51.9358 22.3248 51.9358 21.8641V15.2916ZM61.3994 15.2916L63.8354 19.2739H63.915L66.3511 15.2916H68.1309L64.959 20.3825L68.1508 25.4734H66.361L63.915 21.5459H63.8354L61.3894 25.4734H59.5996L62.8461 20.3825L59.6195 15.2916H61.3994ZM74.2747 25.4734V15.2916L80.6582 15.2916V16.6141H75.8109V19.7163L80.3251 19.7163V21.0338L75.8109 21.0338V24.151L80.7179 24.151V25.4734L74.2747 25.4734Z"
        fill="#298576"
      />
    </svg>
  );
};
